import React from 'react'
import { PropTypes as T } from 'prop-types'
import { connect } from 'react-redux'

const numberToHuman = (number) => {
  if (number >= 1000) {
    const s = ['', 'K', 'M']
    const e = Math.floor(Math.log(number) / Math.log(1000))
    return (number / Math.pow(1000, e)).toFixed(0) + s[e]
  }

  return String(number || 0)
}

const TopicFollowersCount = ({ followersCount, format }) => {
  if (format === 'label') {
    const label = followersCount === 1 ? 'follower' : 'followers'
    return <span>{followersCount} {label}</span>
  }

  return <span>{numberToHuman(followersCount)}</span>
}

TopicFollowersCount.propTypes = {
  followersCount: T.number,
  format: T.string,
}

function mapStateToProps(state, ownProps) {
  const counts = (state.topicFollows && state.topicFollows.counts) || {}
  const followersCount = Object.prototype.hasOwnProperty.call(counts, ownProps.slug)
    ? counts[ownProps.slug]
    : ownProps.followersCount

  return { followersCount }
}

export default connect(mapStateToProps)(TopicFollowersCount)
